import * as React from 'react';

import {useTranslation} from "react-i18next";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import {formatDateToLocaleWithTime} from "../utils";
import {ApplicationHistoryType} from "./types";
import {OAuthDataProps} from "../../../context/type";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";

type ApplicationHistoryProps = {
    data: Array<ApplicationHistoryType>;
    open: boolean;
    handleClose: () => void;
    title: string;
    oauthData: OAuthDataProps;
    loading?: boolean;
}

const ApplicationHistory: React.FC<ApplicationHistoryProps> = ({
                                                                   data,
                                                                   open = false,
                                                                   handleClose,
                                                                   title,
                                                                   oauthData,
                                                                   loading = false
                                                               }) => {
    const {t} = useTranslation('common');

    const getPayloadData = (data: string, key?: string | null) => {
        let json = JSON.parse(data);
        let rows: Array<React.ReactNode> = [];

        if (key && json[key]) {
            json[key].map((name: string) => (
                rows.push(<Typography key={name} variant={"caption"}>{t(name)}<br/></Typography>)
            ))
        }
        return (rows);
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth="xl"
        >
            <DialogTitle>
                {title}
            </DialogTitle>
            <DialogContent>
                {loading ? <Stack gap={2}>
                        <Skeleton variant="rectangular" height={40} sx={{borderRadius: "4px"}}/>
                        <Skeleton variant="rectangular" height={40} sx={{borderRadius: "4px"}}/>
                        <Skeleton variant="rectangular" height={40} sx={{borderRadius: "4px"}}/>
                        <Skeleton variant="rectangular" height={40} sx={{borderRadius: "4px"}}/>
                    </Stack> :
                    <Table stickyHeader sx={{
                        tableLayout: "auto",
                        backgroundColor: "#fff",
                        color: "rgba(0, 0, 0, 0.87)",
                        transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                        borderRadius: "4px",
                        boxShadow: "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
                    }}
                    >
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{
                                    borderTop: "1px solid rgba(224, 224, 224, 1)",
                                    borderTopLeftRadius: "4px",
                                }}>{t("action")}</TableCell>
                                <TableCell
                                    sx={{borderTop: "1px solid rgba(224, 224, 224, 1)"}}>{t("created_on")}</TableCell>
                                <TableCell
                                    sx={{borderTop: "1px solid rgba(224, 224, 224, 1)"}}>{t("issued_by")}</TableCell>
                                <TableCell
                                    sx={{borderTop: "1px solid rgba(224, 224, 224, 1)"}}>{t("next_status")}</TableCell>
                                <TableCell sx={{borderTop: "1px solid rgba(224, 224, 224, 1)"}}></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.length !== 0 && data.map((row, idx) => (
                                <TableRow
                                    key={idx}
                                    sx={{'&:last-child td, &:last-child th': {border: 0}}}
                                >
                                    <TableCell component="th" scope="row"><Typography
                                        variant={"caption"}>{t(row.action)}</Typography></TableCell>
                                    <TableCell component="th" scope="row"><Typography
                                        variant={"caption"}>{formatDateToLocaleWithTime(row.createdAt, oauthData)}</Typography></TableCell>
                                    <TableCell><Typography
                                        variant={"caption"}>{t(row.issuedBy)}</Typography></TableCell>
                                    <TableCell><Typography variant={"caption"}>{t(row.nextStatus!)}</Typography>
                                    </TableCell>
                                    <TableCell>{(row.action === "history-set-application-inquiries") && getPayloadData(row.payload!, "editorInquiries")}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>}
            </DialogContent>
            <DialogActions>
                <Button sx={{m: 2}} onClick={handleClose}>{t("close")}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ApplicationHistory;